
import {Component, Vue} from "vue-property-decorator";
import {safetyModule} from "@/store";
import EventReportTable from "@/components/safety/EventReportTable.vue";
import {MdbsCore} from "@/api/tsclient";
import EventReportDetails from "@/components/safety/EventReportDetails.vue";
import IEventReportItemDto = MdbsCore.IEventReportItemDto;
import {DateTime} from "luxon";

@Component({
  components: {EventReportTable, EventReportDetails}
})
export default class SafetyScreeningReportView extends Vue {

  selectedReferenceId: string = "";

  filterFromDate: Date | null;
  filterToDate: Date | null;

  async mounted() {
    await safetyModule.loadEventReportOverview();
    this.filterEventReports();
  }

  filteredEventReports: Array<IEventReportItemDto> = [];

  filterEventReports() {
    this.filteredEventReports.updateValues(
        safetyModule.EventReportOverview.eventReports
            ?.filter(report => {
              let fromPass = true;
              if (this.filterFromDate != null) {
                if (!report.sendDate) return false;

                fromPass = DateTime.fromJSDate(report.sendDate!).set({hour: 23, minute: 59, second: 59}).toJSDate()
                    >= this.filterFromDate;
              }

              let toPass = true;
              if (this.filterToDate != null) {
                if (!report.sendDate) return false;

                toPass = report.sendDate
                    <= DateTime.fromJSDate(this.filterToDate!).set({hour: 23, minute: 59, second: 59}).toJSDate()
              }

              return fromPass && toPass;
            }) ?? []);
  }

  get institutes() {
    return safetyModule.EventReportOverview.institutes;
  }

  get studyPatients() {
    return safetyModule.EventReportOverview.studyPatients;
  }

  get selectedEventReports(): Array<IEventReportItemDto> {
    if (this.selectedReferenceId == "") {
      return [];
    }

    return this.filteredEventReports
        ?.filter(er => er.referenceId == this.selectedReferenceId) ?? [];
  }

  getSelectedPatientName() {
    if (this.selectedReferenceId == "" || this.selectedEventReports.length == 0) {
      return "";
    }

    const patient = this.studyPatients
        ?.find(p => p.id == this.selectedEventReports[0].studyPatientId);

    return patient?.identifier ?? "";
  }

  handleSelectedRow(referenceId: string) {
    this.selectedReferenceId = referenceId;
  }

  handleFromDateFilterChanged(fromDate: Date | null) {
    this.filterFromDate = fromDate;
    this.filterEventReports();
  }

  handleToDateFilterChanged(toDate: Date | null) {
    this.filterToDate = toDate;
    this.filterEventReports();
  }

}
